module.exports = __webpack_public_path__ + "img/icon_zhiliang@2x.86d758cc.png";